'use client';

import { CSSProperties, Suspense } from 'react';
import dynamic from 'next/dynamic';
import { useTranslations } from 'next-intl';

function TypeformLoading() {
  const t = useTranslations('common');
  return (
    <div style={{ minHeight: '200px', minWidth: '200px' }}>
      {t('typeformSnippet.content.loadingForm')}
    </div>
  );
}

const Widget = dynamic(
  () =>
    import('@typeform/embed-react').then((mod) => ({ default: mod.Widget })),
  {
    ssr: false,
    loading: () => <TypeformLoading />,
  },
);

export type TypeformSubmitEvent = {
  formId: string;
  responseId: string;
};

export const TypeformSnippet = ({
  typeformId,
  className,
  style,
  frameTitle,
  trackingParams,
  onSubmit,
}: {
  typeformId: string;
  className?: string;
  style?: CSSProperties;
  frameTitle?: string;
  trackingParams?: Record<string, string>;
  onSubmit?: (event: TypeformSubmitEvent) => void;
}) => {
  const t = useTranslations('common');

  return (
    <Suspense
      fallback={
        <div style={{ minHeight: '200px', minWidth: '200px' }}>
          {t('typeformSnippet.content.loadingForm')}
        </div>
      }
    >
      <Widget
        id={typeformId}
        inlineOnMobile={true}
        disableScroll={true}
        data-tf-iframe-props={`title=${frameTitle}`}
        data-tf-medium="snippet"
        data-tf-inline-on-mobile
        style={{ minWidth: '200px', minHeight: '200px', ...style }}
        className={`${className} typeformSnippet`}
        tracking={trackingParams ?? {}}
        onSubmit={onSubmit}
      />
    </Suspense>
  );
};
